import { render, staticRenderFns } from "./addKeylinkType.vue?vue&type=template&id=15afc4be&"
import script from "./addKeylinkType.vue?vue&type=script&lang=js&"
export * from "./addKeylinkType.vue?vue&type=script&lang=js&"
import style0 from "./addKeylinkType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports